module.exports = __webpack_public_path__ + "static/media/backslashseven-logo-text-black.d6b5d9b9.svg";